/**
 * Account Manager Endpoints
 * SUPERADMIN: Account Manager management APIs
 */

export const ACCOUNT_MANAGER_ENDPOINTS = {
  list: 'admin/get-manager',
  create: 'admin/create-manager',
  update: 'admin/update-manager',
  delete: 'admin/delete-manager',
  deleteConfirm: 'admin/delete-confirm',
};
